import dayjs from 'dayjs';
import { CardResizeRange } from './types';

export const getTeachingBlockCardGeometry = (
  range: CardResizeRange,
  options?: { anchorDateString?: string; borderMode?: 'grid' | 'virtual' },
) => {
  const start = dayjs(range.startDateString).startOf('day');
  const end = dayjs(range.endDateString).startOf('day');
  const anchorWeekStart = dayjs(options?.anchorDateString ?? range.startDateString)
    .startOf('isoWeek')
    .startOf('day');

  const startOffset = start.diff(anchorWeekStart, 'days');
  const endOffsetInclusive = end.diff(anchorWeekStart, 'days');
  const duration = endOffsetInclusive - startOffset + 1;
  const widthInWeeks = duration / 7;

  if (options?.borderMode === 'virtual') {
    const borders = duration > 7 ? Math.floor(widthInWeeks * 2) - 1 : 1;
    return {
      left: `${(startOffset / 7) * 100}%`,
      width: `calc(${widthInWeeks * 100}% + ${borders}px)`,
    };
  }

  // Border-Px an GANZZAHLIGE Wochen-Grenzen koppeln (nicht an die fraktionale Dauer):
  // pro überquerter Wochenspalten-Grenze 2px (rechte + linke Cell-Border). Aufgeteilt
  // auf left (Grenzen VOR dem Start) und width (Grenzen zwischen Start und Ende), sodass
  // die rechte Kante = left + width ausschließlich vom Ende abhängt. Dadurch bleibt sie
  // beim Start-Resize fix (vorher driftete sie über den dauerabhängigen Px-Term mit).
  const startBoundaries = Math.floor(startOffset / 7);
  const endBoundaries = Math.floor(endOffsetInclusive / 7);
  const leftBorders = startBoundaries * 2;
  const widthBorders = (endBoundaries - startBoundaries) * 2;

  return {
    left: `calc(${(startOffset / 7) * 100}% + ${leftBorders}px)`,
    width: `calc(${widthInWeeks * 100}% + ${widthBorders}px)`,
  };
};
